import { OnInit } from '@angular/core';
import { ShoppingService } from "../../shared/services/shopping.service";
var CheckoutStatusMonitorComponent = /** @class */ (function () {
    function CheckoutStatusMonitorComponent(shopping) {
        this.shopping = shopping;
    }
    CheckoutStatusMonitorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.shopping.getCheckoutStatus().subscribe(function (status) {
            _this.orderStatus = status;
        });
    };
    Object.defineProperty(CheckoutStatusMonitorComponent.prototype, "orderStart", {
        get: function () {
            return this.orderStatus === "ORDER_START";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutStatusMonitorComponent.prototype, "paymentPrepare", {
        get: function () {
            return this.orderStatus === "PAYMENT_PREPARE";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutStatusMonitorComponent.prototype, "orderFinalize", {
        get: function () {
            return this.orderStatus === "ORDER_FINALIZE";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutStatusMonitorComponent.prototype, "orderComplete", {
        get: function () {
            return this.orderStatus === "ORDER_COMPLETE";
        },
        enumerable: true,
        configurable: true
    });
    return CheckoutStatusMonitorComponent;
}());
export { CheckoutStatusMonitorComponent };



// WEBPACK FOOTER //
// ./src/app/admin/checkout-status-monitor/checkout-status-monitor.component.ts.pre-build-optimizer.js